import { LABELS_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import { transformOptionsUsingMultiAction } from '../../../bulk-edit-transform/utils';
import type { JiraLabelsField as LabelsField, JiraLabel as Label } from '../fragment';
import type { LabelsFormData } from './types';

export const transformLabelsFieldForOptimisticUpdates: DataTransformFn<
	LabelsField,
	LabelsFormData
> = (existingField: LabelsField, fieldData: LabelsFormData): LabelsField => {
	const action = fieldData.action;
	const existingLabels =
		existingField.selectedLabelsConnection?.edges?.map((edge) => edge?.node).filter(Boolean) ?? [];
	const labelNodes = transformOptionsUsingMultiAction<Label>({
		existingOptions: existingLabels,
		options: fieldData.value.map((value) => ({
			__typename: 'JiraLabel',
			labelId: null,
			name: value.value,
		})),
		action,
		isEqual: (option: Label, existingOption: Label) => option.name === existingOption.name,
	});
	return {
		...existingField,
		selectedLabelsConnection: {
			__typename: 'JiraLabelConnection',
			edges:
				labelNodes?.map((node) => ({
					__typename: 'JiraLabelEdge',
					node,
				})) ?? null,
		},
	};
};

export const labelsOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<LabelsField, LabelsFormData>;
} = {
	[LABELS_TYPE]: transformLabelsFieldForOptimisticUpdates,
};
